import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { Accounting } from './accounting.types';

export const useAccounting = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<Accounting[]>>({
    queryKey: 'accounting',
    queryFn: () => apiClient.get<Accounting[]>('/accounts'),
    enabled,
  });
};